/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: < Ravi Ranjan Kumar, Ujjwal Singh >

*/

import React from 'react'
import {Backdrop,Paper} from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
    root:{
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
//   zIndex: -1,
  position: 'fixed',
  alignItems: 'center',
  touchAction: 'none',
  justifyContent: 'center',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  webkitTapHighlightColor: 'transparent',
    },
  backdrop: {
    padding:'20px',
    zIndex: theme.zIndex.drawer + 1,
    color: '#f77200',
    textAlign:'center'
  },
  progressBar:{
      background:"transparent",
    }
    ,
    msg:{
      color:'#000'
    }
}))

export default function SimpleBackdrop(props) {
  const classes = useStyles()
 

  return (
    <div className={classes.root}>
      <Paper className={classes.backdrop} open={true} >
        <CircularProgress color="inherit" className={classes.progressBar} size={30}/>
        <br/>
           <p className={classes.msg}>{props.msg}</p>
      </Paper>
    </div>
    
  )
}
